import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import {Item} from '@/components/core';
import Pager from '../_common/pager';
import { Navigation,Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import caseData from '../_data/case'
import caseListData from '../_data/caselist'


const PagesBody = props => {
  const {type, projectBg, solution, cost} = props
  return (
    <div className={"pages-container " + type}>
      <div className="pages-part1">
        <div className="wid1200">
          <div className="item-header">
            <div className="pages-title mb-default">项目背景</div>
          </div>
          {
            projectBg ? (
              <div className="item-body">
                <pre className="item-body-title">{projectBg.title}</pre>
                <img className="item-pic" src={projectBg.img}/>
              </div>
            ) : ''
          }
        </div>
      </div>
      <div className="pages-part2">
        <div className="wid1200">
          <div className="item-header">
            <div className="pages-title mb-default">解决方案</div>
          </div>
          {
            solution ? (
              <div className="item-body">
                <img className="item-pic" src={solution.img}/>
                <pre className="item-body-title">{solution.title}</pre>
              </div>
            ) : ''
          }
        </div>
      </div>
      <div className="pages-part3">
        <div className="wid1200">
          <div className="item-header">
            <div className="pages-title mb-default">明心价值</div>
          </div>
          {
            cost ? (
              <div className="item-body">
                <pre className="item-body-title">{cost.title}</pre>
                <img className="item-pic" src={cost.img}/>
              </div>
            ) : ''
          }
        </div>
      </div>
    </div>
  )
}

const PagesBodyFooter = props => {
  const {data} = props
  return (
    <>
      {
        data.length > 0 ? (
          <div className="case-more">
            <div className="wid1200">
              <div className="item-header">
                <div className="pages-title mb-default">更多案例</div>
              </div>
              <Swiper
                modules={[Navigation, Autoplay]}
                spaceBetween={8}
                slidesPerView={4}
                slidesPerGroup={1}
                navigation
                className="item-body"
                loop={true}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
                onSwiper={
                  (swiper)=>{
                    //鼠标悬浮暂停效果
                    swiper.$el[0].addEventListener('mouseover',()=>swiper.autoplay.stop());
                    //鼠标移开后继续自动滚屏效果
                    swiper.$el[0].addEventListener('mouseleave',()=>swiper.autoplay.start());
                  }
                }
              >
                { data.map((item, idx) => {
                  return (
                    <SwiperSlide key={'case-'+idx} >
                      <a href={"/case?"+item.type} className='ss-item-pic-column'>
                        <div className="item-header">
                            <img src={item.img}/>
                        </div>
                        <div className="item-body">
                          <p>客户案例 - {item.title}</p>
                        </div>
                      </a>
                    </SwiperSlide>
                  )
                }) }
              </Swiper>
            </div>
          </div>
        ) : ''
      }
    </>
  )
}


const App = () => {
  const caseType = window.location.search.split('?')[1]
  const data = caseData.filter(item => item.type === caseType)[0]
  const listData = caseListData
  const cfg = {
    banner: {data: [data.banner]},
    body: <PagesBody {...data} />,
    bodyfooter: <PagesBodyFooter {...listData} />
  }
  return <Pager {...cfg} />
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)